module.exports = __webpack_public_path__ + "static/media/radio_square.0fe399e0.png";